<template>
  <section>
    <div
      class="bssCenten"
      v-for="(item, index) in lensList"
      :key="index"
      @click="details(item)"
      style="cursor: pointer"
    >
      <div class="clearfix">
        <div class="left">
          <div style="margin-top: 18px">{{ item.title }}</div>
        </div>
      </div>
      <!-- <div class="bbs_img clearfix">
                        <img class="left" src="../../imgs/newsList.png" alt="" v-for="o in 3" :key="o">
                    </div> -->
      <div class="bbs_img clearfix">
        <!-- <img :src="item.video_thumb" > -->
        <video width="320" height="240" controls>
          <source :src="item.video" type="video/mp4" />
          {{ $t("您的浏览器不支持 video 标签。") }}
        </video>
      </div>
      <div class="ulLi">
        <ul class="clearfix">
          <li class="left">
            <div class="row clearfix">
              <div
                class="col-lg-9 col-md-8 col-sm-12 cl-card-main left"
                style="height: 24px; line-height: 24px"
              >
                <div class="left img">
                  <img
                    :src="item.head_img"
                    alt=""
                    style="height: 24px; line-height: 24px"
                  />
                </div>
                <div class="left" style="margin: 0 8px; color: #666666; font-size: 14px">
                  {{ item.user_nickname }}
                </div>
                <div
                  class="left"
                  style="
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                  "
                >
                  {{ item.create_time }}
                </div>
              </div>
            </div>
          </li>

          <li class="right">
            <div class="left" style="margin-right: 32px">
              <i class="el-icon-view"></i>
              <span>{{ item.see_number }}</span>
            </div>
            <div class="left" style="margin-right: 32px">
              <img src="@/imgs/39.png" alt="" style="width: 14px; height: 14px" />
              <span>{{ item.pl_number }}</span>
            </div>
            <div class="left">
              <img src="@/imgs/43.png" alt="" style="width: 14px; height: 14px" />
              <span>{{ item.like_number }}</span>
            </div>
          </li>
        </ul>
      </div>
      <el-divider></el-divider>
    </div>
  </section>
</template>
<script>
export default {
  name: "bbs",
  components: {},
  data() {
    return {};
  },
  props: ["lensList"],

  created() {},
  methods: {
    //   论坛详情
    details(item) {
      console.log("item", item);
      this.$router.push({
        url: "/bbsDetails",
        name: "bbsDetails",
        query: { userId: item.article_id },
      });
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
.bssCenten {
  background: #ffffff;
  .luntan {
    width: 40px;
    height: 21px;
    background: #f87863;
    border-radius: 2px 2px 2px 2px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
    margin-top: 13px;
  }
  .bbs_img {
    margin: 16px 0;
    img {
      width: 248px;
      height: 172px;
    }
    img:nth-child(3) {
      float: right;
    }
    img:nth-child(2) {
      margin: 0 31px;
    }
  }
  .clearfix {
    margin-top: 10px;
    // padding: 20px 24px;
    box-sizing: border-box;
    .left {
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .ulLi {
    li {
      text-align: center;
    }
    li:first-child {
      text-align: left;
    }
    li:last-child {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeIndex/video.vue